<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12">
        <b-card>
          <div class="invoice-nav px-4">
            <div
              class="cursor-pointer"
              style="color: #3f77f5"
              @click="$router.go(-1)"
            >
              <i
                class="fas fa-arrow-left"
                style="color: #3f77f5; font-size: 15px"
              ></i>
              Go to invoices
            </div>
            <b-button
              v-if="unpaid"
              class=" text-white"
              @click="addPayment"
              style="border-radius: 15px"
              variant="success"
              >Pay Invoice</b-button
            >
          </div>
          <div
            class="card m-3 px-4 py-2 rounded-lg b-grid justify-content-between"
          >
            <b-row :cols="{ unpaid: 2, paid: 3 }" align-v="center">
              <b-col>
                <p class="b-title h-auto h3">Invoice</p>
              </b-col>
              <b-col v-if="paid" class="align-items-center justify-content-center">
                <div class="d-flex flex-row justify-content-center border border-success rounded align-items-center w-25 mx-auto">
                  <p class="text-success text-center m-1 w-100">PAID</p>
                </div>
              </b-col>
              <b-col
                class="
                  d-flex
                  justify-content-end
                  flex-column
                  align-items-end
                  text-black-50
                  lower-font-size
                "
              >
                <div class="font-weight-bold pb-2">
                  {{ organizationName ?? "" }}
                </div>
                <div style="line-height: 15px; text-align: right">
                  <div>
                    {{ organizationAddressLine1 ?? "" }}
                    {{ organizationAddressLine2 ?? "" }}
                  </div>
                  <div>{{ organizationCity ?? "" }}</div>
                  <div>
                    {{
                      organizationAbbreviation ? organizationAbbreviation : ""
                    }}
                  </div>
                  <div>{{ organizationZipCode ?? "" }}</div>
                </div>
              </b-col>
            </b-row>
            <hr />
            <b-row class="d-flex justify-content-between align-content-center">
              <b-col
                class="
                  d-flex
                  justify-content-start
                  flex-column
                  align-items-start
                  text-black-50
                  lower-font-size
                "
              >
                <div class="font-weight-bold pt-2">Bill To</div>
                <div v-for="item in billTo" :key="item.index">
                  {{ item }}
                </div>
              </b-col>
              <b-col
                class="
                  d-flex
                  justify-content-end
                  flex-column
                  align-items-end
                  text-black-50
                  lower-font-size
                "
              >
                <div class="font-weight-bold pt-2">Invoice #</div>
                <div>{{ invoice?.refNumber ?? "" }}</div>
                <div class="font-weight-bold pt-2">Issued</div>
                <div>{{ formatDateOnly(issuedDate) ?? "" }}</div>
                <div v-if="showDueDate" class="font-weight-bold pt-2">Due</div>
                <div v-if="showDueDate">{{ formatDateOnly(dueDate) ?? "" }}</div>
              </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between align-content-center">
              <b-col
                class="
                  d-flex
                  justify-content-start
                  flex-column
                  align-items-start
                  text-black-50
                  lower-font-size
                "
              >
                <div class="font-weight-bold pt-2">Client</div>
                <div v-for="item in clientData" :key="item.index">
                  {{ item }}
                </div>
              </b-col>
              <b-col
                class="
                  d-flex
                  justify-content-start
                  flex-column
                  align-items-start
                  text-black-50
                  lower-font-size
                "
              >
                <div class="font-weight-bold pt-2">Provider</div>
                <div v-for="item in providerData" :key="item.index">
                  {{ item }}
                </div>
              </b-col>
            </b-row>
            <hr class="pb-2 mb-0" />
            <div class="w-100">
              <table class="w-100 text-black-50 lower-font-size">
                <thead>
                  <tr>
                    <th class="font-weight-bold">Date</th>
                    <th class="font-weight-bold">Description</th>
                    <th class="font-weight-bold text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoice?.invoiceLineItems" :key="item.id">
                    <td class="py-2 pr-2">{{ formatDateOnly(item.date) }}</td>
                    <td class="py-2">{{ item.description }}</td>
                    <td class="text-right py-2">
                      {{ toCurrencyValue(item.amount) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr class="my-0 py-0" />
            <div
              class="d-flex justify-content-end py-2 text-black-50 lower-font-size text-right"
            >
              <div>Subtotal</div>
              <div style="width:100px;">
                {{ toCurrencyValue(invoice?.totalAmount ?? "") }}
              </div>
            </div>
            <hr class="align-self-end my-0 py-0" style="width: 35%" />
            <div
              class="d-flex justify-content-end py-2 text-black-50 lower-font-size text-right"
            >
              <div>Total</div>
              <div style="width:100px;">
                {{ toCurrencyValue(invoice?.totalAmount ?? "") }}
              </div>
            </div>
            <div
              class="d-flex justify-content-end py-2 text-black-50 lower-font-size text-right"
            >
              <div>Amount Paid</div>
              <div style="width:100px;">
                {{ toCurrencyValue(invoice?.amountPaid ?? "") }}
              </div>
            </div>
            <hr class="align-self-end my-0 py-0" style="width: 35%" />
            <div
              class="d-flex justify-content-end py-2 text-black-50 font-weight-bold text-right"
            >
              <div>Balance</div>
              <div v-if="invoice != null" style="font-size: 20px;width:100px; ">
                {{ toCurrencyValue(invoice.totalAmount - invoice.amountPaid) }}
              </div>
              <div v-else style="font-size: 20px;width:100px;">
                {{ "" }}
              </div>
            </div>
            <b-row cols="1">
              <b-col cols="12">
                <div class="font-weight-bold lower-font-size text-black-50">
                  Notes
                </div>
                <div
                  class="w-100 lower-font-size"
                  v-for="item in notes"
                  :key="item.index"
                >
                  {{ item }}
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { defineComponent } from "vue";
import { billingServer } from "../../server/billing";
export default defineComponent({
  props: {
    invoiceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      invoice: null,
      lineItemsData: null,
      patientName: "",
      issuedDate: null,
      dueDate: null,
      notes: "",
      billTo: [],
      organizationAbbreviation: "",
      clientData: [],
      providerData: []
    };
  },
  async mounted() {
    await this.fetchStates();
    await this.fetchInvoiceDetails();
  },
  computed: {
    ...mapState("session", {
      organizationName: state => state.systemSettings.organizationName,
      organizationLogo: state => state.systemSettings.organizationLogo,
      organizationAddressLine1: state =>
        state.systemSettings.organizationAddressLine1,
      organizationAddressLine2: state =>
        state.systemSettings.organizationAddressLine2,
      organizationCity: state => state.systemSettings.organizationCity,
      organizationState: state => state.systemSettings.organizationState,
      organizationZipCode: state => state.systemSettings.organizationZipCode,
      showDueDate: state => !state.systemSettings.invoiceHideDueDate
    }),
    ...mapState("client", {
      states: state => state.states
    })
  },
  methods: {
    ...mapActions("client", ["fetchStates"]),
    async fetchInvoiceDetails() {
      const abbr = this.states.find(
        state => state.id === this.organizationState
      );
      this.organizationAbbreviation = abbr ? abbr.abbreviation : "";
      try {
        const response = await billingServer.getInvoice(this.invoiceId);
        this.invoice = response.data;
        this.patientName = this.invoice.episodeOfCare.patient.name;
        this.unpaid = this.invoice.totalAmount - this.invoice.amountPaid > 0;
        this.paid = !this.unpaid;
        this.issuedDate = this.invoice.dateFrom ?? null;
        this.dueDate = this.invoice.dateTo ?? null;
        this.notes = this.invoice.notes.split("\n");
        this.billTo = this.invoice.billTo?.split("\n");
        this.clientData = this.invoice.clientData?.split("\n");
        this.providerData = this.invoice.providerData?.split("\n");
      } catch (error) {
        console.error(error);
      }
    },
    addPayment() {
      this.$router.push({
        name: "InvoicePayment",
        params: {
          invoiceId: this.invoiceId,
          totalAmount: this.invoice.totalAmount - this.invoice.amountPaid,
          refNumber: this.invoice.refNumber
        }
      });
    }
  }
});
</script>

<style scoped>
.invoice-nav {
  background-color: #f5f6f9;
  display: flex;
  border-radius: 15px;
  height: 50px;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
</style>
